import React, { useState, useEffect, useRef } from "react";
import { Container, Button, Card, CardBody, Col, Row } from "reactstrap";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import * as moment from "moment";

import { Link, withRouter } from "react-router-dom";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import DeleteModal from "components/Common/DeleteModal";
import DeleteAllModal from "components/Common/DeleteAllModal";
import InvoiceDetailModal from "pages/Ecommerce/EcommerceCustomers/EcommerceCustomerDetail/InvoiceDetailModal";

//Import Card invoice
// import CardInvoice from "./card-invoice";
import { getInvoices as onGetInvoices } from "store/actions";

const InvoicesList = props => {
  const dispatch = useDispatch();

  const { SearchBar } = Search;
  var node = useRef();

  const { invoices } = useSelector(state => ({
    invoices: state.invoices.invoices,
  }));

  const [data, setData] = useState([]);
  const [deleteAllModal, setDeleteAllModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const [invoiceId, setInvoiceId] = useState();
  const [modal_xlarge, setmodal_xlarge] = useState(false);

  useEffect(() => {
    dispatch(onGetInvoices());
  }, []);

  useEffect(() => {
    if (invoices?.data && invoices?.data?.length) {
      setData(invoices?.data);
    }
  }, [invoices]);

  console.log(data);

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data?.length,
    custom: true,
  };

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const invoiceColumns = [
    {
      dataField: "customerId.username",
      text: "Customer Name",
    },
    {
      dataField: "_id",
      text: "Invoice Id",
    },
    {
      dataField: "orderDate",
      text: "Order Date",
      sort: true,
      formatter: (cellContent, row) =>
        handleValidDate(row.orderDate.slice(0, 10)),
    },
    {
      dataField: "totalPrice",
      text: "Total Amount",
      sort: true,
      formatter: (cell, row, rowIndex) => <span>{`₹ ${row?.totalPrice}`}</span>,
    },
    {
      dataField: "view",
      text: "View Invoice",
      formatter: (cell, row) => (
        <>
          <Button
            type="button"
            color="primary"
            className="btn-sm btn-rounded"
            onClick={() => {
              tog_xlarge();
              setInvoiceDetail(row);
            }}
          >
            View Invoice
          </Button>
        </>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <>
          <i
            onClick={() => {
              setDeleteModal(true);
              // setInvoiceId(row._id);
            }}
            className="mdi mdi-delete font-size-16"
            style={{ color: "#f46a6a" }}
          />
        </>
      ),
    },
  ];

  /*deleting all Invoice */
  const handleDeleteAllInvoice = () => {
    // dispatch(deleteAllInvoice(id));
    setDeleteAllModal(false);
  };

  const handleDeleteInvoice = () => {
    // dispatch(deleteInvoice(id, invoiceId));
    setDeleteModal(false);
  };

  //large-modal
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  return (
    <React.Fragment>
      <DeleteAllModal
        show={deleteAllModal}
        onDeleteClick={handleDeleteAllInvoice}
        onCloseClick={() => setDeleteAllModal(false)}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteInvoice}
        onCloseClick={() => setDeleteModal(false)}
      />
      <InvoiceDetailModal
        show={modal_xlarge}
        onToggleClick={tog_xlarge}
        onCloseClick={() => setmodal_xlarge(false)}
        invoiceDetail={invoiceDetail}
      />
      <div className="page-content">
        <MetaTags>
          <title>Invoice List | Scrollit</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Invoices" breadcrumbItem="Invoice List" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={invoiceColumns}
                    data={data}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={data}
                        columns={invoiceColumns}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row
                              className="mb-2"
                              style={{ justifyContent: "space-between" }}
                            >
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="4" style={{ textAlign: "end" }}>
                                <Button
                                  type="button"
                                  color="danger"
                                  className="btn-rounded"
                                  onClick={() => {
                                    setDeleteAllModal(true);
                                  }}
                                >
                                  <i className="mdi mdi-delete me-1" />
                                  Delete All Invoice
                                </Button>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="_id"
                                    data={data}
                                    columns={invoiceColumns}
                                    headerClasses="table-light"
                                    classes={
                                      "table align-middle table-nowrap table-check "
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

InvoicesList.propTypes = {
  invoices: PropTypes.array,
  onGetInvoices: PropTypes.func,
};

export default withRouter(InvoicesList);
